import { Component, lazy } from "react";
import classes from "./keikkaInfoBanner.module.css";
import AikaContainer from "./components/AikaContainer";
import AsiakasContainer from "./components/AsiakasContainer";
import CommentContainer from "./components/CommentContainer";
import { KeikkaIdContainer } from "./components/KeikkaIdContainer";
import { Box, Grid, Stack } from "@mui/material";
import PropTypes from "prop-types";
import LazyLoader from "src/components/layout/Progress/LazyLoader";

const _belowAikaContainer = import("./components/BelowAikaContainer");
const BelowAikaContainer = lazy(() => _belowAikaContainer);
const _pumppuContainer = import("./components/PumppuContainer");
const PumppuContainer = lazy(() => _pumppuContainer);
const _betoniContainer = import("./components/BetoniContainer");
const BetoniContainer = lazy(() => _betoniContainer);

export class KeikkaInfoBanner extends Component {
  state = { keikkaLasku: null, keikkaData: "", user: "", rows: 6 };
  constructor(props) {
    super(props);
    const { keikkaData, keikkaLasku, rows } = props;
    const { navTo } = props;
    this.state = { keikkaData, keikkaLasku, navTo, rows, height: "30px" };
  }

  componentDidUpdate() {
    if (this.divElement) {
      const _height = this.divElement.offsetHeight;
      if (_height === this.state.height) return;
      this.setState({ height: _height });
    }
  }

  render() {
    const {
      state: { navTo, height },
    } = this;
    const stepId = this.props.stepId;
    const keikkaData = this.props.keikkaData;
    const rows = this.props.rows || 6;
    const noBorder = this.props.noBorder || false;
    const borderString = noBorder ? "0px" : "1px solid gray";

    let mainBoxClassName = classes.mainbox_sticky;
    if (stepId === 5) mainBoxClassName = classes.mainbox;

    return (
      <Box sx={{ boxShadow: 2 }} className="noPrint">
        <div className={mainBoxClassName} style={{ border: borderString }}>
          {keikkaData.keikkaId > 0 && (
            <>
              <Grid container s="aikaosoite" sx={{ width: "100%" }}>
                <Grid
                  size={{ xs: 4 }}
                  component={Stack}
                  justifyContent="center"
                  onClick={() => navTo(3)}
                  className={classes.borderRight}
                  aria-label="Muokkaa aikaa">
                  <AikaContainer rows={rows} />
                </Grid>

                <Grid
                  size={{ xs: 8 }}
                  component={Stack}
                  justifyContent="left"
                  onClick={() => navTo(1)}
                  className={classes.borderBottom}
                  aria-label="Muokkaa toimitusosoitetta">
                  <AsiakasContainer keikkaData={keikkaData} rows={rows} />
                  <KeikkaIdContainer
                    keikkaId={keikkaData.keikkaId}
                    varmenne={keikkaData.varmenne}
                  />
                </Grid>
              </Grid>
              {rows > 2 && keikkaData.modules.hasPumppu && (
                <>
                  <Grid container s="pumppu" sx={{ width: "100%" }}>
                    <Grid
                      size={{ xs: 4 }}
                      onClick={() => navTo(5)}
                      className={classes.borderBottomRight}>
                      <BelowAikaContainer />
                    </Grid>
                    <Grid size={{ xs: 8 }} component={Stack} className={classes.borderBottom}>
                      <PumppuContainer keikkaData={keikkaData} navTo={navTo} />
                    </Grid>
                  </Grid>
                </>
              )}
              {keikkaData.modules.hasBetoni && (
                <Box className={classes.borderBottom} sx={{ bgcolor: "info.main" }}>
                  <div
                    style={{
                      position: "relative",
                      width: "100%",
                      height: height,
                      transition: "height 1.3s ease-out",
                    }}>
                    <div style={{ position: "absolute", width: "100%" }}>
                      <div
                        ref={(divElement) => {
                          this.divElement = divElement;
                        }}>
                        {keikkaData.betoni.map((obj, index) => {
                          // betonit
                          if (index > 4) return <div key={obj.keikkaBetoniId} />;

                          return (
                            <div key={obj.keikkaBetoniId}>
                              <LazyLoader txt="Ladataan BetoniContainer at KeikkaInfoBanner.jsx">
                                <BetoniContainer
                                  key={obj.keikkaBetoniId}
                                  keikkaData={keikkaData}
                                  navTo={navTo}
                                  rows={rows}
                                  keikkaBetoniId={obj.keikkaBetoniId}
                                />
                              </LazyLoader>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </Box>
              )}
              <Box
                className={classes.borderBottom}
                sx={{ bgcolor: "info.main" }}
                onClick={() => navTo(6)}
                aria-label="Muokkaa huomioita">
                <CommentContainer keikkaData={keikkaData} rows={rows} />
              </Box>
              {/* <div>
                {showHintaBanner(keikkaData, keikkaLasku, user) && rows > 5 && (
                  <LaskutusTiedotContainer />
                )}
              </div> */}
            </>
          )}
        </div>
      </Box>
    );
  }
}

export default KeikkaInfoBanner;

KeikkaInfoBanner.propTypes = {
  keikkaData: PropTypes.object,
  rows: PropTypes.number,
  stepId: PropTypes.number,
  navTo: PropTypes.func,
  setKeikkaBetoniId: PropTypes.func,
  noBorder: PropTypes.bool,
  user: PropTypes.object,
  keikkaLasku: PropTypes.object,
};
